import { TriangleAlertIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type ErrorAlertProps = {
	title: ReactNode;
	description: ReactNode;
	className?: string;
	variant?: 'destructive' | 'ghost';
};
export default function ErrorAlert({ title, className, description, variant = 'destructive' }: ErrorAlertProps) {
	return (
		<Alert className={cn('text-red-500 dark:text-red-500', className)} variant={variant}>
			<AlertTitle className="flex items-center gap-2">
				<TriangleAlertIcon size={16} />
				<span>{title}</span>
			</AlertTitle>
			<AlertDescription className="text-red-400 dark:text-red-400 pl-6">{description}</AlertDescription>
		</Alert>
	);
}
